// Feature flag controlling visibility of the Journey Previewer.
// Toggle in the Flipper system; the route and Path-detail entrypoint
// are both gated on this name.
export const JOURNEY_PREVIEWER_FEATURE_FLAG = "journey_previewer";
